export const DEFAULT_LEVEL_COLOR = '#ff4df2';

const clampChannel = (value) => Math.max(0, Math.min(255, Math.round(value)));

const parseHexColor = (value) => {
	if (!value || typeof value !== 'string') {
		return null;
	}

	const hex = value.trim().replace('#', '');

	if (hex.length === 3) {
		const red = Number.parseInt(hex[0] + hex[0], 16);
		const green = Number.parseInt(hex[1] + hex[1], 16);
		const blue = Number.parseInt(hex[2] + hex[2], 16);

		if ([red, green, blue].some((channel) => Number.isNaN(channel))) {
			return null;
		}

		return { red, green, blue };
	}

	if (hex.length === 6) {
		const red = Number.parseInt(hex.slice(0, 2), 16);
		const green = Number.parseInt(hex.slice(2, 4), 16);
		const blue = Number.parseInt(hex.slice(4, 6), 16);

		if ([red, green, blue].some((channel) => Number.isNaN(channel))) {
			return null;
		}

		return { red, green, blue };
	}

	return null;
};

const mixToward = (source, target, amount) => ({
	red: clampChannel(source.red + (target.red - source.red) * amount),
	green: clampChannel(source.green + (target.green - source.green) * amount),
	blue: clampChannel(source.blue + (target.blue - source.blue) * amount),
});

const toHex = ({ red, green, blue }) => {
	const toPart = (channel) => channel.toString(16).padStart(2, '0');

	return `#${toPart(red)}${toPart(green)}${toPart(blue)}`;
};

export const toRgba = (color, alpha) => {
	const rgb = parseHexColor(color) || parseHexColor(DEFAULT_LEVEL_COLOR);

	return `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue}, ${alpha})`;
};

export const getFlamePalette = (color) => {
	const base =
		parseHexColor(color) || parseHexColor(DEFAULT_LEVEL_COLOR);
	const white = { red: 255, green: 255, blue: 255 };
	const cream = { red: 255, green: 253, blue: 226 };

	return {
		base: toHex(base),
		outerStart: toHex(mixToward(base, white, 0.08)),
		outerMid: toHex(mixToward(base, cream, 0.28)),
		outerEnd: toHex(mixToward(base, cream, 0.62)),
		innerStart: toHex(mixToward(cream, white, 0.35)),
		innerMid: toHex(mixToward(base, cream, 0.45)),
		innerEnd: toHex(base),
		shine: toHex(mixToward(base, white, 0.72)),
	};
};
